import wds from '@wix/design-system/package.json';
import { minimalRequiredRuntimeCheck } from './utils/minimalRequiredRuntimeCheck';

export function minimalRequiredWdsRuntimeCheck({
  required,
  requiredBy,
}: {
  required: string;
  requiredBy?: string;
}) {
  return minimalRequiredRuntimeCheck({
    packageJson: wds,
    required,
    requiredBy,
  });
}
